<div [formGroup]="formGroup" class="container-checkbox">
    <input type="checkbox" id="{{ id }}" [attr.disabled]="readonly" [formControlName]="controlName" [name]="name">
    <label [for]="id">{{title}}</label>
</div>
